export const getUniqueNameWithCopyCounter = <T>(name: string, items: T[], getNameFn: (item: T) => string): string => {
  const originalName = name
  let copyCounter = 0

  while (items.some((item) => getNameFn(item) === name)) {
    copyCounter += 1
    name = `${originalName} (${copyCounter})`
  }

  return name
}
